/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DimensionReportLineItem } from "./DimensionReportLineItem";
import {
  DimensionReportLineItemFromJSON,
  DimensionReportLineItemFromJSONTyped,
  DimensionReportLineItemToJSON,
  DimensionReportLineItemToJSONTyped,
} from "./DimensionReportLineItem";

/**
 *
 * @export
 * @interface DimensionReportSupportEmailInput
 */
export interface DimensionReportSupportEmailInput {
  /**
   *
   * @type {string}
   * @memberof DimensionReportSupportEmailInput
   */
  carrierInvoiceId: string;
  /**
   *
   * @type {Array<DimensionReportLineItem>}
   * @memberof DimensionReportSupportEmailInput
   */
  reportLineItems: Array<DimensionReportLineItem>;
  /**
   *
   * @type {string}
   * @memberof DimensionReportSupportEmailInput
   */
  extraText: string;
}

/**
 * Check if a given object implements the DimensionReportSupportEmailInput interface.
 */
export function instanceOfDimensionReportSupportEmailInput(
  value: object,
): value is DimensionReportSupportEmailInput {
  if (!("carrierInvoiceId" in value) || value["carrierInvoiceId"] === undefined)
    return false;
  if (!("reportLineItems" in value) || value["reportLineItems"] === undefined)
    return false;
  if (!("extraText" in value) || value["extraText"] === undefined) return false;
  return true;
}

export function DimensionReportSupportEmailInputFromJSON(
  json: any,
): DimensionReportSupportEmailInput {
  return DimensionReportSupportEmailInputFromJSONTyped(json, false);
}

export function DimensionReportSupportEmailInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DimensionReportSupportEmailInput {
  if (json == null) {
    return json;
  }
  return {
    carrierInvoiceId: json["carrierInvoiceId"],
    reportLineItems: (json["reportLineItems"] as Array<any>).map(
      DimensionReportLineItemFromJSON,
    ),
    extraText: json["extraText"],
  };
}

export function DimensionReportSupportEmailInputToJSON(
  json: any,
): DimensionReportSupportEmailInput {
  return DimensionReportSupportEmailInputToJSONTyped(json, false);
}

export function DimensionReportSupportEmailInputToJSONTyped(
  value?: DimensionReportSupportEmailInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierInvoiceId: value["carrierInvoiceId"],
    reportLineItems: (value["reportLineItems"] as Array<any>).map(
      DimensionReportLineItemToJSON,
    ),
    extraText: value["extraText"],
  };
}
